import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CartouchesService, Cartouche } from '../../../../services/cartouches.service';
import { Chimie, ChimieService } from '../../../../services/chimie.service';
import { LotCartouche, LotsCartouchesService } from '../../../../services/lots-cartouches.service';

@Component({
	selector: 'app-cartouche-list',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './cartouche-list.component.html',
	styleUrl: './cartouche-list.component.scss'
})
export class CartoucheListComponent implements OnInit {
	cartouches: Cartouche[] = [];
	filtered: Cartouche[] = [];
	filter = '';
	chimieFilter: number | null = null;
	page = 1;
	pageSize = 10;
	loading = false;
	error = '';
	deletingId: number | null = null;
	lots: LotCartouche[] = [];
	chimies: Chimie[] = [];

	constructor(
		private readonly cartouchesService: CartouchesService,
		private readonly router: Router,
		private readonly lotsCartouchesService: LotsCartouchesService,
		private readonly chimieService: ChimieService,
		private readonly cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.lotsCartouchesService.list().subscribe({
			next: lots => { this.lots = lots; this.cdr.detectChanges(); },
			error: () => { this.lots = []; this.cdr.detectChanges(); }
		});
		this.chimieService.list().subscribe({
			next: chimies => { this.chimies = chimies; this.cdr.detectChanges(); },
			error: () => { this.chimies = []; this.cdr.detectChanges(); }
		});
		this.loadCartouches();
	}

	loadCartouches(): void {
		this.loading = true;
		this.cartouchesService.list().subscribe({
			next: (cartouches) => {
				this.cartouches = cartouches;
				this.applyFilter();
				this.loading = false;
				this.cdr.detectChanges();
			},
			error: () => {
				this.error = 'Erreur lors du chargement des cartouches';
				this.loading = false;
				this.cdr.detectChanges();
			}
		});
	}

	applyFilter(): void {
		const f = this.filter.trim().toLowerCase();
		const chimieId = this.chimieFilter;
		this.filtered = this.cartouches.filter(c =>
			(!f || (c.nom && c.nom.toLowerCase().includes(f))) &&
			(chimieId == null || c.chimie_id === chimieId)
		);
		this.page = 1;
	}

	get paged(): Cartouche[] {
		const start = (this.page - 1) * this.pageSize;
		return this.filtered.slice(start, start + this.pageSize);
	}

	pageCount(): number {
		return Math.ceil(this.filtered.length / this.pageSize) || 1;
	}

	getLotNom(id: number | undefined): string {
		const lot = this.lots.find(l => l.id === id);
		return lot ? lot.nom : '';
	}

	getChimieNom(id: number | undefined): string {
		const chimie = this.chimies.find(c => c.id === id);
		return chimie ? chimie.nom : '';
	}

	goToEdit(id: number): void {
		this.router.navigate(['/intranet/gestion-stocks/cartouches/modifier'], { queryParams: { id } });
	}

	deleteCartouche(id: number): void {
		if (!confirm('Supprimer cette cartouche ?')) return;
		this.deletingId = id;
		this.cartouchesService.delete(id).subscribe({
			next: () => {
				this.loadCartouches();
				this.deletingId = null;
				this.cdr.detectChanges();
			},
			error: () => {
				this.error = 'Erreur lors de la suppression.';
				this.deletingId = null;
				this.cdr.detectChanges();
			}
		});
	}
}
